import { render, staticRenderFns } from "./CustomerInfoSection.vue?vue&type=template&id=5711da08&scoped=true"
import script from "./CustomerInfoSection.vue?vue&type=script&lang=js"
export * from "./CustomerInfoSection.vue?vue&type=script&lang=js"
import style0 from "./CustomerInfoSection.vue?vue&type=style&index=0&id=5711da08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5711da08",
  null
  
)

export default component.exports